module.exports = __webpack_public_path__ + "assets/img/employment-banner.add94570.jpg";